export default class ListingType {
  constructor({ classification = 1, id = 0, label = "" }) {
    this.classification = classification;
    this.id = id;
    this.label = label;
    this.enabled = false
  }
}
